export default __webpack_public_path__ + "static/media/DW3.d3c0a6e9.png";